import { useState } from "react";
import { useTranslation } from 'react-i18next';
import { Box, Paper, Text } from "@mantine/core";

/**
 * Grid picker for selecting table dimensions (rows x cols).
 */
function TablePicker({ onSelect, onClose }) {
  const { t } = useTranslation();
  const [hoveredRows, setHoveredRows] = useState(0);
  const [hoveredCols, setHoveredCols] = useState(0);
  const maxRows = 10;
  const maxCols = 10;

  const handleCellHover = (row, col) => {
    setHoveredRows(row + 1);
    setHoveredCols(col + 1);
  };

  const handleCellClick = (row, col) => {
    onSelect(row + 1, col + 1);
    onClose();
  };

  const handleMouseLeave = () => {
    setHoveredRows(0);
    setHoveredCols(0);
  };

  return (
    <Paper
      shadow="md"
      p="md"
      style={{ position: "absolute", top: "calc(100% + 4px)", left: 0, zIndex: 1300, minWidth: 280 }}
      onMouseLeave={handleMouseLeave}
    >
      <Box style={{ display: "grid", gridTemplateColumns: `repeat(${maxCols}, 1fr)`, gap: 2, marginBottom: 8 }}>
        {Array.from({ length: maxRows }).map((_, rowIndex) =>
          Array.from({ length: maxCols }).map((_, colIndex) => {
            const isHovered = rowIndex < hoveredRows && colIndex < hoveredCols;
            return (
              <Box
                key={`${rowIndex}-${colIndex}`}
                onMouseEnter={() => handleCellHover(rowIndex, colIndex)}
                onClick={() => handleCellClick(rowIndex, colIndex)}
                style={{ width: 20, height: 20, border: "1px solid #e0e0e0", backgroundColor: isHovered ? "var(--mantine-color-blue-6)" : "#f5f5f5", cursor: "pointer", transition: "background-color 0.1s" }}
              />
            );
          })
        )}
      </Box>
      <Text size="xs" c="dimmed">
        {hoveredRows > 0 && hoveredCols > 0 ? `${hoveredRows} x ${hoveredCols}` : "Select table size"}
      </Text>
    </Paper>
  );
}

export default TablePicker;
